import { useDeleteSensitiveDataMutation } from "apis/sensitiveData";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { useToast } from "hooks/useToast";
import { useParams } from "react-router-dom";
import { BackendError } from "types/utils/error";

export const DeleteSensitiveDataModal = ({
  isOpen,
  close,
  sensitiveDataId,
  onDeleted,
}: {
  isOpen: boolean;
  close: () => void;
  sensitiveDataId: string;
  onDeleted?: () => void;
}) => {
  const [deleteSensitiveData, { isLoading: isDeleting }] =
    useDeleteSensitiveDataMutation();
  const { entityId } = useParams<{ entityId: string }>();
  const { alertToast, successToast } = useToast();

  const handleDelete = async () => {
    try {
      await deleteSensitiveData({ entityId, formId: sensitiveDataId }).unwrap();
      successToast({ message: "Sensitive data deleted successfully" });
      close();
      onDeleted?.();
    } catch (error) {
      alertToast({
        message:
          (error as BackendError).data?.error?.message ??
          "Something went wrong",
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small" aria-label="Delete sensitive data">
        <StatusModal type="danger" title="Delete sensitive data?">
          You’re about to delete sensitive data, are you sure you want to
          proceed?
        </StatusModal>
        <Modal.Footer className="t-flex t-justify-end t-gap-3">
          <Button type="button" onClick={close} disabled={isDeleting}>
            Go back
          </Button>
          <Button
            type="button"
            customType="danger"
            onClick={handleDelete}
            isLoading={isDeleting}
            disabled={isDeleting}
          >
            Yes, delete
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
